/**
 * Formato visual CLABE: grupos con espacios (18 dígitos).
 * El valor en react-hook-form debe ser solo dígitos.
 */
export const formatCLABE = (clabe) => {
  const cleaned = String(clabe ?? '').replace(/\D/g, '')

  return cleaned.split('').reduce((acc, digit, index) => {
    if (index === 3 || index === 6) {
      return acc + '  ' + digit
    }
    if (index === 17) {
      return acc + '  ' + digit
    }
    return acc + digit
  }, '')
}
